// dependencies
import { useQuery } from "@tanstack/react-query";

// api services
import { getEmployeeFields } from "../../services/defs/employee-fields";

export const useEmployeeFields = () => {
	const fieldsQuery = useQuery({
		queryKey: ["company-fields"],
		queryFn: () => getEmployeeFields(),
		meta: {
			errorMessage: "There was an error getting the employee fields.",
		},
	});

	const fields = {
		employeeFields: fieldsQuery?.data?.data_fields || [],
		warnings: fieldsQuery?.data?.warnings || [],
		errors: fieldsQuery?.data?.errors || [],
		isLoading: fieldsQuery?.isLoading,
	};

	return fields;
};
